import { css } from 'styled-components';
export const dayWrapper = css `
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
